var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("no-ssr", [
    _c(
      "section",
      { staticClass: "container-full" },
      [
        _c("header-inner"),
        _c(
          "wrapper",
          {
            staticClass: "page--top",
            attrs: { lineBorders: false, lineCenter: true }
          },
          [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "title" }, [
                _c("h1", [
                  _vm._v("Данной страницы"),
                  _c("br"),
                  _vm._v(" не существует")
                ])
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5ea9138", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5ea9138","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/error.vue
// module id = J1QK
// module chunks = 41